import { FC } from 'react'
import { motion } from 'framer-motion'
import { Button } from '@/atoms/Button'
import { useTranslate } from '@/utils/translate/translate-client'

interface Props {
  onClick: () => void
}

export const FloatingCtaButton: FC<Props> = ({ onClick }) => {
  const { t } = useTranslate('tickets')

  return (
    <motion.div
      initial={{ y: 100, opacity: 0 }}
      animate={{
        y: 0,
        opacity: 1,
        transition: { type: 'tween', duration: 0.3 },
      }}
      className="fixed inset-x-0 bottom-0 z-50 bg-black p-6 md:hidden"
      style={{
        background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.3) 100%)',
      }}
    >
      <Button
        onClick={onClick}
        className="w-full border-none bg-giveaway-secondary !font-medium"
        variant="core-gray-900"
        size="lg"
      >
        {t('preOrderTicketsV2', 'Preorder Tickets')}
      </Button>
    </motion.div>
  )
}
